import React, {memo, useCallback, useEffect, useRef, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {useKeyboard} from "../../hooks/keyboard"
import {useRPC} from "../../hooks/rpc"
import {useMessage} from "../../hooks/message"
import {onClickHandler} from "../../utils/onclick"
import {removeSession} from "../../utils/session-storage"
import {clearUserAction} from "../../store/user/action"
import {useLocalization} from "../../hooks/localization"
import {useHistory} from "react-router-dom"
import "./index.scss"

export const ResetPassword = memo(function ResetPassword() {
    const {t} = useLocalization()
    const history = useHistory()
    const [rpc] = useRPC()
    const dispatch = useDispatch()
    const resetPasswordList = useSelector(state => state.control.userResetPassword)
    const {failure} = useMessage();

    const newPasswordRef = useRef<HTMLInputElement>()
    const newAlarmPasswordRef = useRef<HTMLInputElement>()

    const [setActivePassword, renderNumpad] = useKeyboard("numpad", true)
    const [newPassword, setNewPassword] = useState("")
    const [newAlarmPassword, setNewAlarmPassword] = useState("")
    const [isPassed, setIsPassed] = useState(false)

    const passwordValidation = newPassword.match("[0-9]{1}[0-9]{1}[0-9]{1}[0-9]{1}[0-9]{1}[0-9]{1}")
    const alarmPasswordValidation = newAlarmPassword.match("[0-9]{1}[0-9]{1}[0-9]{1}[0-9]{1}")


    useEffect(() => {
        if (!resetPasswordList?.first_login) {
            return history.push("/")
        }
    }, [resetPasswordList, history])

    const onFocusNewPassword = useCallback(
        () => setActivePassword([newPasswordRef, newPassword, setNewPassword]),
        [newPassword, setActivePassword]
    )

    const onFocusNewAlarmPassword = useCallback(
        () => setActivePassword([newAlarmPasswordRef, newAlarmPassword, setNewAlarmPassword]),
        [newAlarmPassword, setActivePassword]
    )

    const onBlur = useCallback(() => setActivePassword(null), [setActivePassword])

    const isFieldsValid = useCallback((): boolean => {
        if (newPassword.length !== 6 || newPassword == null || !passwordValidation) {
            return false
        }
        if (newAlarmPassword.length !== 4 || newAlarmPassword == null || !alarmPasswordValidation) {
            return false
        }
        return true
    }, [newPassword, newAlarmPassword, passwordValidation, alarmPasswordValidation])

    const onClick = useCallback(() => {
        if (!isFieldsValid()) {
            return
        }
        rpc.ResetUserPassword(
            resetPasswordList?.user_name,
            resetPasswordList?.current_password,
            newPassword,
            resetPasswordList?.auth_code,
            newAlarmPassword,
        ).then(() => {
            rpc.doLogout()
            dispatch(clearUserAction())
            removeSession()
            history.push("/login")
            window.location.reload()
        }).catch(failure)
    }, [dispatch, history, failure, isFieldsValid, rpc, newPassword, newAlarmPassword, resetPasswordList])

    useEffect(() => {
        if (
            newPassword.length === 6 &&
            newAlarmPassword.length === 4 &&
            passwordValidation &&
            alarmPasswordValidation
        ) {
            setIsPassed(true)
        } else {
            setIsPassed(false)
        }
    }, [newPassword, newAlarmPassword, passwordValidation, alarmPasswordValidation])

    return (
        <>
            <div className="reset-password-container">
                <div className="reset-password">
                    <span>Yeni Şifre Belirle</span>
                    <input
                        type="password"
                        maxLength={6}
                        placeholder={"Yeni Şifre"}
                        ref={newPasswordRef}
                        onChange={e => setNewPassword(e.target.value)}
                        className="reset-input-button"
                        onFocus={onFocusNewPassword}
                        onBlur={onBlur}
                        value={newPassword}
                    />
                    <input
                        type="password"
                        maxLength={4}
                        placeholder={"Yeni Alarm Şifre"}
                        ref={newAlarmPasswordRef}
                        onChange={e => setNewAlarmPassword(e.target.value)}
                        className="reset-input-button"
                        onFocus={onFocusNewAlarmPassword}
                        onBlur={onBlur}
                        value={newAlarmPassword}
                    />
                    <button
                        className="reset-button"
                        {...onClickHandler(onClick)}
                        disabled={!isPassed}
                        style={{backgroundColor: isPassed ? "#31d10065" : "rgb(119, 119, 119)"}}
                    >
                        {t("approve")}
                    </button>
                </div>
                {renderNumpad()}
            </div>
        </>
    )
})
